<h5 class="typo-h5 mb-4">
  {{
    'workflows.mistakes_form.title'
      | translate: { requestNumber: context['data'].request.requestNumber }
  }}
</h5>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <p class="my-8">{{ 'workflows.mistakes_form.instruction' | translate }}</p>

  @if ($loadError(); as loadError) {
    <div
      class="mb-4 rounded-lg px-3 py-2 typo-body-s"
      role="alert"
      style="
        background: var(--tui-status-negative-pale);
        color: var(--tui-text-negative);
      "
    >
      {{ 'workflows.mistakes_form.load_error' | translate }}: {{ loadError }}
    </div>
  }

  <tui-loader [loading]="$loading()" [overlay]="true">
    <div formArrayName="mistakes">
      @for (mistake of form.controls['mistakes'].controls; track $index) {
        <div [formGroupName]="$index" class="mb-4">
          @let checkboxControl = mistake.get('selected');
          <label class="flex gap-4 x-font-body-4 mb-2">
            <input
              tuiCheckbox
              type="checkbox"
              formControlName="selected"
              size="m"
              class="ms-1"
            />

            {{ mistakesTypes[$index].name }}
          </label>

          @if (checkboxControl?.value) {
            <label class="flex gap-4 x-font-body-4 mb-2 items-center relative">
              {{ 'workflows.mistakes_form.comment_label' | translate }}
              <tui-textfield
                class="grow"
                tuiTextfieldSize="s"
                [tuiTextfieldCleaner]="true"
              >
                <input tuiInput formControlName="comment" />
              </tui-textfield>
            </label>
          }
        </div>
      }
    </div>
  </tui-loader>

  @if (hasSelected()) {
    <p class="my-8">
      {{ 'workflows.mistakes_form.submit_description' | translate }}
      <b>"{{ 'workflows.mistakes_form.status_name' | translate }}"</b>
    </p>
  } @else if ($existingCount() > 0) {
    <p class="my-8">
      {{ 'workflows.mistakes_form.clear_description' | translate }}
    </p>
  }

  <div class="flex justify-end mt-10 gap-5">
    <button
      tuiButton
      appearance="secondary"
      type="button"
      size="m"
      (click)="onCancel()"
    >
      {{ 'workflows.mistakes_form.cancel_button' | translate }}
    </button>
    <button
      tuiButton
      type="submit"
      size="m"
      [class.cursor-not-allowed]="!canSubmit()"
      [class.cursor-pointer]="canSubmit()"
      [disabled]="!canSubmit()"
    >
      @if (!hasSelected() && $existingCount() > 0) {
        {{ 'workflows.mistakes_form.clear_button' | translate }}
      } @else {
        {{ 'workflows.mistakes_form.save_button' | translate }}
      }
    </button>
  </div>
</form>
